// Redux Actions
import {
  ADD_NC_ROOT,
  UNSHIFT_NC_ROOT,
  CLEAR_NC_ROOT,
  CLEAR_TYPE_NC_ROOT,
  ADD_NC_CONTENT,
  CLEAR_NC_CONTENT,
  RESET_NC_STATE,
  SET_NC_STATE_POSITION_BACK,
  SET_NC_STATE_POSITION_NEXT,
  SET_NC_STATE_POSITION_PREVIOUS,
  SET_NC_STATE_LEVEL_NEXT
} from "../types";

export function addNCRoot(payload) {
  return { type: ADD_NC_ROOT, payload }
}

export function unshiftNCRoot(payload) {
  return { type: UNSHIFT_NC_ROOT, payload }
}

export function clearNCRoot(payload) {
  return { type: CLEAR_NC_ROOT }
}

export function clearTypeNCRoot(payload) {
  return { type: CLEAR_TYPE_NC_ROOT, payload }
}

export function addNCContent(payload) {
  return { type: ADD_NC_CONTENT, payload }
}

export function clearNCContent(payload) {
  return { type: CLEAR_NC_CONTENT }
}

export function resetNCState() {
  return { type: RESET_NC_STATE }
}

export function backNCSPosition() {
  return { type: SET_NC_STATE_POSITION_BACK }
};

export function nextNCSPosition() {
  return { type: SET_NC_STATE_POSITION_NEXT }
};

export function previousNCSPosition() {
  return { type: SET_NC_STATE_POSITION_PREVIOUS }
};

export function nextNCSLevel() {
  return { type: SET_NC_STATE_LEVEL_NEXT }
};
